// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__Wnc9i","footer":"page_footer__PkEbB"};